// @flow

export type ReadingDirectionCode =
  | 'LEFT_TO_RIGHT'
  | 'RIGHT_TO_LEFT';

export type ReadingDirection = {
  code: ReadingDirectionCode,
};

export const LEFT_TO_RIGHT: ReadingDirection = {
  code: 'LEFT_TO_RIGHT',
};

export const RIGHT_TO_LEFT: ReadingDirection = {
  code: 'RIGHT_TO_LEFT',
};
